import PropTypes from 'prop-types';
import { cn } from 'Utils/cn';

const Divider = ({ className, children }) => {
    if (children) {
        return (
            <div className={cn('flex w-full items-center gap-2 text-gray-500', className)}>
                <hr className="flex-1 h-[1px] bg-gray-200 border-0" />
                <span className="shrink-0">{children}</span>
                <hr className="flex-1 h-[1px] bg-gray-200 border-0" />
            </div>
        );
    }

    return <hr className={cn('w-full h-[1px] bg-gray-200 border-0 my-1', className)} />;
};

Divider.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
};

export default Divider;
